import React from 'react';
import { withTheme } from '@emotion/react';
import getDefaultTheme from '../themes/default.js';
export default (UnthemedComponent) => {
    return withTheme((props) => {
        return props.theme && props.theme.type ? (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        React.createElement(UnthemedComponent, { ...props })) : (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        React.createElement(UnthemedComponent, { ...props, theme: getDefaultTheme((props.theme ?? {})) }));
    });
};
// TODO: memoize it?
